import axios from 'axios';

// Используем относительный URL для API, чтобы избежать проблем с SSL
// Если REACT_APP_BACKEND_URL не установлен, используем относительный путь
const getApiUrl = () => {
  // В production всегда используем относительный URL
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    // Если URL указан и это localhost, используем его
    if (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
      return envUrl;
    }
    // Для production используем относительный путь, чтобы избежать проблем с SSL
    return '';
  }
  // По умолчанию для development
  return 'http://localhost:8000';
};

const API_URL = getApiUrl();

/**
 * Получить токен авторизации из localStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

/**
 * Создать axios instance с авторизацией
 */
export const getAuthenticatedAxios = () => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return axios.create({
    baseURL: API_URL || '', // Пустая строка означает относительный URL
    headers,
  });
};

/**
 * Проверить, требуется ли повторная авторизация
 */
export const handleAuthError = (error, toast) => {
  if (error.response?.status === 401) {
    toast?.error('Ошибка авторизации. Пожалуйста, войдите снова.');
    // Можно также перенаправить на страницу логина
    // window.location.href = '/login';
    return true;
  }
  return false;
};

export { API_URL, getApiUrl };

